const Menu = [
    {
        name: 'New Trip Sheet',
        path: '/trips/create',
        icon: 'fas fa-calculator',
        roles: [1],
        code: 'VE'
    }, {
        name: 'Trip Sheets',
        path: '/trips/',
        icon: 'fas fa-truck',
        roles: [1],
        code: 'VE'
    }

];

export default Menu;
